import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: Array<Record<string, unknown>>;
  }
}

const GTMPageView = () => {
  const location = useLocation();

  useEffect(() => {
    // Push virtual pageview to GTM dataLayer on route change
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtualPageview",
      pagePath: location.pathname,
      pageTitle: document.title,
    });
  }, [location.pathname]);

  return null;
};

export default GTMPageView;
